let enabled = false;

export const isValidateContractContractingPartyEnabled = () => enabled;

export const setValidateContractContractingParty = (value: boolean) => {
  enabled = value;
};
